export enum FrameworkEnumTypes {
  RISK_FRAMEWORK_ENUM = 'risk framework enum',
  STANDARD_ENUM = 'standard enum',
  VENDOR_RISK_FRAMEWORK_ENUM = 'vendor risk framework enum',
  CERTIFICATIONS_ENUM = 'certifications enum',
  FRAMEWORKS_ANSWERS_ENUMS = 'frameworks answers enum',
  LICENSE_NOTICE_ENUM = 'license notice enum',
}
